const DEALER_SEARCH_PHONE_CALLED_HIT_ORIGIN = 'Dealer Search Phone Called'
const DEALER_PROVINCE_SEARCH_PHONE_CALLED_HIT_ORIGIN = 'Dealer Province Search Phone Called'

const DEALER_SEARCH_EVENT_VERSION = 1
const DEFAULT_EVENT_VERSION = 2

const dealerStockClickedEventVersionsMapper = ({payload}) => {
  const {obj: {properties: {hit_origin: hitOrigin} = {}} = {}} = payload

  const isDealerSearchHitOrigin =
    hitOrigin === DEALER_SEARCH_PHONE_CALLED_HIT_ORIGIN || hitOrigin === DEALER_PROVINCE_SEARCH_PHONE_CALLED_HIT_ORIGIN

  return isDealerSearchHitOrigin ? DEALER_SEARCH_EVENT_VERSION : DEFAULT_EVENT_VERSION
}

export default dealerStockClickedEventVersionsMapper
